import { ConfigurationError } from "@cian/core/errors/index.mjs";
function yieldToMainThread() {
    if (globalThis.scheduler?.yield) return globalThis.scheduler.yield();
    return new Promise((resolve)=>setTimeout(resolve, 0));
}
const ERR_DOMAIN = 'analytics.lib';
const caAsync = async (command, ...args)=>{
    await yieldToMainThread();
    window.ca(command, ...args, {
        version: "1.3.2-CD-248981.0"
    });
};
function ca(command, ...args) {
    if ('undefined' == typeof window) throw new ConfigurationError({
        message: "\u041D\u0435\u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0426\u0438\u0430\u043D \u0410\u043D\u0430\u043B\u0438\u0442\u0438\u043A\u0443 \u0432\u043D\u0435 \u0431\u0440\u0430\u0443\u0437\u0435\u0440\u0430",
        domain: ERR_DOMAIN
    });
    caAsync(command, ...args);
}
export { ca };
